import CinematicEarthAnimation from "@/components/CinematicEarthAnimation";
import { Link } from "react-router-dom";
import { Shield, BarChart3, Rocket } from "lucide-react";

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
      style={{ background: 'linear-gradient(135deg, #0a0a0a 0%, #111827 50%, #0a1628 100%)' }}
    >
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `
          linear-gradient(rgba(15, 61, 46, 0.3) 1px, transparent 1px),
          linear-gradient(90deg, rgba(15, 61, 46, 0.3) 1px, transparent 1px)
        `,
        backgroundSize: '50px 50px'
      }} />

      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-0">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-[80vh]">
          <div className="space-y-8 z-10 pt-20 lg:pt-0">
            <div className="space-y-4">
              <h1 className="font-montserrat text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight leading-tight">
                <span className="block text-white">Turn Compliance</span>
                <span className="block bg-gradient-to-r from-emerald-400 via-teal-300 to-[#1F4E79] bg-clip-text text-transparent">
                  into Profit
                </span>
              </h1>
              <p className="text-base sm:text-lg font-medium text-slate-400 tracking-wide">
                Environmental Compliance &nbsp;|&nbsp; Carbon Markets &nbsp;|&nbsp; Climate Infrastructure
              </p>
            </div>
            
            <p className="text-lg text-slate-400 leading-relaxed max-w-xl">
              India's end-to-end platform for environmental approvals, carbon strategy, and sustainable infrastructure development.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-3 pt-2">
              <Link to="/environmental-compliance" className="inline-flex items-center gap-2 px-5 py-3 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-lg transition-all shadow-lg shadow-emerald-500/20" data-testid="hero-cta-compliance">
                <Shield className="h-4 w-4" />
                Check Compliance Status
              </Link>
              <Link to="/emission-calculator" className="inline-flex items-center gap-2 px-5 py-3 border border-emerald-500/50 text-emerald-400 hover:bg-emerald-500/10 font-semibold rounded-lg transition-all" data-testid="hero-cta-carbon">
                <BarChart3 className="h-4 w-4" />
                Calculate Carbon Impact
              </Link>
              <Link to="/climate-projects" className="inline-flex items-center gap-2 px-5 py-3 border border-slate-600 text-slate-300 hover:bg-slate-800 font-semibold rounded-lg transition-all" data-testid="hero-cta-project">
                <Rocket className="h-4 w-4" />
                Start a Project
              </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-4">
              <div className="text-center sm:text-left">
                <p className="text-3xl sm:text-4xl font-bold text-white" data-testid="stat-market">₹850B+</p>
                <p className="text-sm text-slate-500 mt-1">Global Carbon Market</p>
              </div>
              <div className="text-center sm:text-left">
                <p className="text-3xl sm:text-4xl font-bold text-emerald-400" data-testid="stat-netzero">2070</p>
                <p className="text-sm text-slate-500 mt-1">India Net Zero Target</p>
              </div>
              <div className="text-center sm:text-left">
                <p className="text-3xl sm:text-4xl font-bold text-[#1F4E79]" data-testid="stat-reduction">45%</p>
                <p className="text-sm text-slate-500 mt-1">Emissions Reduction Goal</p>
              </div>
            </div>
          </div>

          <div className="relative h-[400px] sm:h-[500px] lg:h-[600px] flex items-center justify-center">
            <CinematicEarthAnimation />
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
